<template>
  <div>
    <Search :searchForm="searchForm" title="" />
    <!-- <Table></Table> -->
    <!-- <UserTree></UserTree> -->
  </div>
</template>
<script>
import UserTree from "@/components/search/UserTree.vue";
import Search from "@/components/search/Search.vue";
import Table from "@/components/table.vue";
import { CRM_USER_TREE } from "@/util/keys";
import { agentAccountConfig } from "../../../../components/search/templateConfig.js";
export default {
  data() {
    return {
      searchForm: agentAccountConfig,
      titleData: [
        {
          key: 1,
          fixed: true,
          prop: "date",
          label: "日期",
          width: "150",
          emptyText: false
        },
        {
          key: 2,
          fixed: false,
          prop: "name",
          label: "姓名",
          width: "120",
          emptyText: false
        },
        {
          key: 3,
          fixed: false,
          prop: "province",
          label: "省份",
          width: "120",
          emptyText: false
        },
        {
          key: 4,
          fixed: false,
          prop: "city",
          label: "市区",
          width: "120",
          emptyText: false
        },
        {
          key: 5,
          fixed: false,
          prop: "address",
          label: "地址",
          width: "120",
          emptyText: false
        },
        {
          key: 6,
          fixed: false,
          prop: "zip",
          label: "邮编",
          width: "120",
          emptyText: false
        }
      ],
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1517 弄",
          zip: 200333
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1519 弄",
          zip: 200333
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1516 弄",
          zip: 200333
        }
      ]
    };
  },
  methods: {
    async getUser() {
      let UserTree = JSON.parse(sessionStorage.getItem(CRM_USER_TREE) || "[]");
      if (UserTree <= 0) {
        UserTree = await getUserTree();
        UserTree = UserTree.code === 0 ? UserTree.data : [];
        sessionStorage.setItem(CRM_USER_TREE, JSON.stringify(UserTree));
      }
      this.setState({ UserTree });
      console.log("UserTree", UserTree);
    }
  },
  components: {
    Search,
    UserTree,
    Table
  },
  mounted() {}
};
</script>
./templateConfig.js
